export default "/ressources/logged/img/icon/svg/ai-icon-write-square.svg";